"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAcTable = void 0;
var react_1 = require("react");
var useAcTable = function (_a) {
    var name = _a.name, _b = _a.initialPage, initialPage = _b === void 0 ? 1 : _b, _c = _a.initialPageSize, initialPageSize = _c === void 0 ? 30 : _c, _d = _a.initialSorts, initialSorts = _d === void 0 ? [] : _d, _e = _a.initialFilter, initialFilter = _e === void 0 ? {} : _e, _f = _a.initialExternalState, initialExternalState = _f === void 0 ? {} : _f, _g = _a.maxPageSize, maxPageSize = _g === void 0 ? 50 : _g, onChangePage = _a.onChangePage, onChangePageSize = _a.onChangePageSize, onChangeSorts = _a.onChangeSorts, onChangeFilter = _a.onChangeFilter, onSelectRow = _a.onSelectRow, onDeselectRow = _a.onDeselectRow, onSelectAllPageData = _a.onSelectAllPageData, onDeselectAllPageData = _a.onDeselectAllPageData, onClearSelectedDataIds = _a.onClearSelectedDataIds;
    var localStoragePageSizeKey = "UseAcPageDataList-" + name + "-pageSize";
    var getLocalStoragePageSize = function () {
        if (localStorage) {
            var _pageSize = parseInt(localStorage.getItem(localStoragePageSizeKey) || '0', 10);
            if (_pageSize > 0 && _pageSize <= maxPageSize) {
                return _pageSize;
            }
        }
        return undefined;
    };
    var _h = __read(react_1.useState(initialPage), 2), page = _h[0], setPage = _h[1];
    var _j = __read(react_1.useState(getLocalStoragePageSize() || initialPageSize), 2), pageSize = _j[0], setPageSize = _j[1];
    var _k = __read(react_1.useState(initialSorts || []), 2), sorts = _k[0], setSorts = _k[1];
    var _l = __read(react_1.useState(initialFilter), 2), filter = _l[0], setFilter = _l[1];
    var _m = __read(react_1.useState(initialExternalState), 2), externalState = _m[0], setExternalState = _m[1];
    var _o = __read(react_1.useState([]), 2), selectedDataIds = _o[0], setSelectedDataIds = _o[1];
    var _p = __read(react_1.useState([]), 2), expandedDataIds = _p[0], setExpandedDataIds = _p[1];
    var _q = __read(react_1.useState([]), 2), data = _q[0], setData = _q[1];
    var _r = __read(react_1.useState(false), 2), isAllPageDataSelected = _r[0], setIsAllPageDataSelected = _r[1];
    var _s = __read(react_1.useState(false), 2), isAllRecordSelected = _s[0], setIsAllRecordSelected = _s[1];
    var _t = __read(react_1.useState(false), 2), isSelectorDisabled = _t[0], setIsSelectorDisabled = _t[1];
    var _u = __read(react_1.useState([]), 2), acTableColumns = _u[0], setAcTableColumns = _u[1];
    react_1.useEffect(function () {
        var allSelected = false;
        if ((data === null || data === void 0 ? void 0 : data.length) > 0 && (selectedDataIds === null || selectedDataIds === void 0 ? void 0 : selectedDataIds.length) > 0) {
            allSelected = true;
            data.forEach(function (d) {
                if (selectedDataIds.indexOf(d === null || d === void 0 ? void 0 : d.id) === -1) {
                    allSelected = false;
                }
            });
        }
        setIsAllPageDataSelected(allSelected);
    }, [data, selectedDataIds]);
    var updatePage = function (updatedPage) {
        if (updatedPage) {
            setPage(updatedPage);
            onChangePage === null || onChangePage === void 0 ? void 0 : onChangePage(updatedPage);
        }
    };
    var updatePageSize = function (updatedPageSize) {
        if (updatedPageSize) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(localStoragePageSizeKey, "" + updatedPageSize);
            setPageSize(updatedPageSize);
            setPage(1);
            onChangePageSize === null || onChangePageSize === void 0 ? void 0 : onChangePageSize(updatedPageSize);
        }
    };
    var updateSorts = function (updatedSorts) {
        setPage(1);
        setSorts(updatedSorts);
        onChangeSorts === null || onChangeSorts === void 0 ? void 0 : onChangeSorts(updatedSorts);
    };
    var updateFilter = function (updatedFilter) {
        setPage(1);
        setFilter(updatedFilter);
        onChangeFilter === null || onChangeFilter === void 0 ? void 0 : onChangeFilter(updatedFilter);
    };
    var resetSorts = function () {
        setPage(1);
        setSorts(initialSorts);
    };
    /**
     * Row Expand State for the AcTable
     */
    var _v = __read(react_1.useState(false), 2), isExpandAll = _v[0], setIsExpandAll = _v[1];
    var toggleExpandAll = function () {
        setIsExpandAll(!isExpandAll);
    };
    var selectRow = function (rowData) {
        var id = rowData === null || rowData === void 0 ? void 0 : rowData.id;
        if (id) {
            if (selectedDataIds.indexOf(id) === -1) {
                setSelectedDataIds(selectedDataIds.slice().concat([id]));
                onSelectRow === null || onSelectRow === void 0 ? void 0 : onSelectRow(rowData);
            }
        }
    };
    var deselectRow = function (rowData) {
        var id = rowData === null || rowData === void 0 ? void 0 : rowData.id;
        if (id) {
            var index = selectedDataIds.indexOf(id);
            if (index !== -1) {
                var cloned = selectedDataIds.slice();
                cloned.splice(index, 1);
                setSelectedDataIds(cloned);
                onDeselectRow === null || onDeselectRow === void 0 ? void 0 : onDeselectRow(rowData);
            }
        }
    };
    var clearSelectedDataIds = function () {
        var cloned = selectedDataIds.slice();
        setSelectedDataIds([]);
        setIsAllRecordSelected(false);
        onClearSelectedDataIds === null || onClearSelectedDataIds === void 0 ? void 0 : onClearSelectedDataIds(cloned);
    };
    var selectAllPageData = function () {
        if ((data === null || data === void 0 ? void 0 : data.length) > 0 && !isSelectorDisabled) {
            var addedDataIds_1 = [];
            var cloned_1 = selectedDataIds.slice();
            var selectorObject_1 = acTableColumns.find(function (column) { return column.selector; });
            data.forEach(function (d) {
                if (cloned_1.indexOf(d === null || d === void 0 ? void 0 : d.id) === -1) {
                    if (!(selectorObject_1 === null || selectorObject_1 === void 0 ? void 0 : selectorObject_1.enableSelector) || selectorObject_1.enableSelector(d)) {
                        cloned_1.push(d === null || d === void 0 ? void 0 : d.id);
                        addedDataIds_1.push(d === null || d === void 0 ? void 0 : d.id);
                    }
                }
            });
            if (selectedDataIds.length !== cloned_1.length) {
                setSelectedDataIds(cloned_1);
            }
            onSelectAllPageData === null || onSelectAllPageData === void 0 ? void 0 : onSelectAllPageData(addedDataIds_1);
        }
    };
    var deselectAllPageData = function () {
        if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
            var removedDataIds_1 = [];
            var cloned_2 = selectedDataIds.slice();
            data.forEach(function (d) {
                var index = cloned_2.indexOf(d === null || d === void 0 ? void 0 : d.id);
                if (index !== -1) {
                    cloned_2.splice(index, 1);
                    removedDataIds_1.push(d === null || d === void 0 ? void 0 : d.id);
                }
            });
            if (selectedDataIds.length !== cloned_2.length) {
                setSelectedDataIds(cloned_2);
            }
            onDeselectAllPageData === null || onDeselectAllPageData === void 0 ? void 0 : onDeselectAllPageData(removedDataIds_1);
        }
    };
    var addExpandedDataId = function (dataId) {
        var _a;
        if (!((_a = expandedDataIds === null || expandedDataIds === void 0 ? void 0 : expandedDataIds.includes) === null || _a === void 0 ? void 0 : _a.call(expandedDataIds, dataId))) {
            setExpandedDataIds(expandedDataIds.concat([dataId]));
        }
    };
    var removeExpandedDataId = function (dataId) {
        var ids = expandedDataIds.filter(function (_id) { return _id !== dataId; });
        setExpandedDataIds(ids);
    };
    return {
        page: page,
        setPage: setPage,
        pageSize: pageSize,
        setPageSize: setPageSize,
        sorts: sorts,
        setSorts: setSorts,
        resetSorts: resetSorts,
        filter: filter,
        externalState: externalState,
        setExternalState: setExternalState,
        updatePage: updatePage,
        updatePageSize: updatePageSize,
        updateSorts: updateSorts,
        updateFilter: updateFilter,
        isExpandAll: isExpandAll,
        toggleExpandAll: toggleExpandAll,
        selectedDataIds: selectedDataIds,
        setSelectedDataIds: setSelectedDataIds,
        expandedDataIds: expandedDataIds,
        setExpandedDataIds: setExpandedDataIds,
        addExpandedDataId: addExpandedDataId,
        removeExpandedDataId: removeExpandedDataId,
        selectRow: selectRow,
        deselectRow: deselectRow,
        clearSelectedDataIds: clearSelectedDataIds,
        selectAllPageData: selectAllPageData,
        deselectAllPageData: deselectAllPageData,
        isAllPageDataSelected: isAllPageDataSelected,
        isAllRecordSelected: isAllRecordSelected,
        setIsAllRecordSelected: setIsAllRecordSelected,
        isSelectorDisabled: isSelectorDisabled,
        setIsSelectorDisabled: setIsSelectorDisabled,
        data: data,
        setData: setData,
        setAcTableColumns: setAcTableColumns,
    };
};
exports.useAcTable = useAcTable;
//# sourceMappingURL=UseAcTable.js.map